import { render, staticRenderFns } from "./CommentUserRow.vue?vue&type=template&id=1ab47162&scoped=true&"
import script from "./CommentUserRow.vue?vue&type=script&lang=ts&"
export * from "./CommentUserRow.vue?vue&type=script&lang=ts&"
import style0 from "./CommentUserRow.vue?vue&type=style&index=0&id=1ab47162&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab47162",
  null
  
)

export default component.exports